import { defineComponent as _defineComponent } from 'vue'
import store from '@/store'
// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-ignore
import { getDateFormattedForPicker, getTimeFormatted } from '@/services/date'
import CreateEventCancel from '@/pages/CreateEventProcessingPage/ui/CreateEventCancel.vue'
import { mdiCalendarCheckOutline, mdiClockOutline } from '@mdi/js'
import { EventDB } from '@/enitites/event'
import { CreateEventFormName } from '@/pages/CreateEventProcessingPage/model/types'
import { computed, inject, ref } from 'vue'


export default /*#__PURE__*/_defineComponent({
  __name: 'CreateEventDate',
  props: {
    isNew: { type: Boolean },
    screen: null,
    eventData: null,
    backStep: { type: Boolean }
  },
  emits: ["update:screen", "updateEvent", "saveAsDraft"],
  setup(__props: any, { emit }: { emit: ({
  (e: 'update:screen', value: CreateEventFormName): void
  (e: 'updateEvent'): void
  (e: 'saveAsDraft'): void
}), expose: any, slots: any, attrs: any }) {

const props = __props as {
  isNew: boolean
  screen: CreateEventFormName
  eventData: EventDB
  backStep: boolean
};

// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-ignore




const menuDateStart = ref(false)
const menuDateEnd = ref(false)
const dateStart = ref(getDateFormattedForPicker(props.eventData.dateStart) || '')
const dateEnd = ref(getDateFormattedForPicker(props.eventData.dateEnd) || '')
const timeStart = ref(getTimeFormatted(props.eventData.dateStart) || '12:00')
const timeEnd = ref(getTimeFormatted(props.eventData.dateEnd) || '12:00')
const loadingNextBtn = ref(false)
const currentDotNav = ref(2)
const error = ref<string | null>(null)

function createDateTime(date: string, time: string) {
  return new Date(`${date.replace(/-/g, '/')} ${time}`)
}

const isInvalidDate = computed(() => {
  return (
    createDateTime(dateEnd.value, timeEnd.value).getTime() < createDateTime(dateStart.value, timeStart.value).getTime()
  )
})
const injectedIsClickBtnNext = inject<{
  updateIsClickBtnNext: (value: boolean) => void
}>('isClickBtnNext')

function handlerClickNext() {
  error.value = null

  if (isInvalidDate.value) {
    error.value = "End Date can't be before the Start Date"
  }

  props.eventData.dateStart = createDateTime(dateStart.value, timeStart.value)
  props.eventData.dateEnd = createDateTime(dateEnd.value, timeEnd.value)

  loadingNextBtn.value = true
  emit('updateEvent')
  injectedIsClickBtnNext?.updateIsClickBtnNext(true)
  emit('update:screen', props.backStep ? 'CreateEventTotal' : 'CreateEventTiers')
  loadingNextBtn.value = false
}

function handlerClickBack() {
  injectedIsClickBtnNext?.updateIsClickBtnNext(false)
  emit('update:screen', 'CreateEventInfo')
}

function handlerClickCancelEdit() {
  emit('update:screen', 'CreateEventTotal')
}

return { __sfc: true,props, emit, menuDateStart, menuDateEnd, dateStart, dateEnd, timeStart, timeEnd, loadingNextBtn, currentDotNav, error, createDateTime, isInvalidDate, injectedIsClickBtnNext, handlerClickNext, handlerClickBack, handlerClickCancelEdit, store, CreateEventCancel, mdiCalendarCheckOutline, mdiClockOutline }
}

})